const LangFranceFlag = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="11" viewBox="0 0 16 11" fill="none">
    <rect width="5.33" height="11" fill="#0055A4" />
    <rect width="5.33" height="11" x="5.33" fill="#FFFFFF" />
    <rect width="5.33" height="11" x="10.66" fill="#EF4135" />
  </svg>
);

export default LangFranceFlag;
